import { render } from "./ComboboxControl.vue?vue&type=template&id=01228d86&scoped=true"
import script from "./ComboboxControl.vue?vue&type=script&lang=js"
export * from "./ComboboxControl.vue?vue&type=script&lang=js"

import "./ComboboxControl.vue?vue&type=style&index=0&id=01228d86&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01228d86"]])

export default __exports__